// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"b6b0a376","237":"dab16646","368":"12092e3d","406":"fef6afdd","420":"449b750e","509":"b9f9522b","552":"ebc7fa93","562":"58b7cc52","705":"cb72a7ee","715":"1d846e0e","729":"44ac5bad","774":"ee282b8d","984":"4acb3f3b"}[chunkId] + ".chunk.js";
};